import { render, staticRenderFns } from "./SignupReport.vue?vue&type=template&id=023fa35a&"
import script from "./SignupReport.vue?vue&type=script&lang=js&"
export * from "./SignupReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports